export const defaultTransition = { delay: 1, duration: 0.5, ease: [0, 0.71, 0.2, 1.01], type: "spring", stiffness: 200, damping: 20 }

export const IMG_SIZE = { width: 550, height: 220 }